// extracted by mini-css-extract-plugin
export default {"filter-group":"FilterGroup_filter-group__fIvbA"};